"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _localization = require("@lt/localization");
var SearcherEmptyHint = function SearcherEmptyHint(_ref) {
  var hint = _ref.hint,
    hasButton = _ref.hasButton,
    isHotelOnly = _ref.isHotelOnly;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var defaultText = hasButton ? t('hotel.searcher.emptyHint.hasButton', {
    context: isHotelOnly ? 'hotel' : 'package'
  }) : t('hotel.searcher.emptyHint.noButton', {
    context: isHotelOnly ? 'hotel' : 'package'
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hint || defaultText);
};
var _default = exports["default"] = SearcherEmptyHint;